import { Redirect } from 'expo-router';

export default function PartnerOnboarding() {
  return <Redirect href="/partner/cars?onboarding=1" />;
}
